import { z } from "zod";

import { CancelMembershipFormValues } from "./types";

export const INITIAL_VALUES_CANCEL_MEMBERSHIP_FORM: CancelMembershipFormValues =
  {
    date: null,
    cancellationReason: null,
  };

export const cancelMembershipFormSchema = z
  .object({
    cancellationReason: z
      .object({
        id: z.union([z.string(), z.number()]),
        label: z.string(),
        value: z.custom<number>(),
      })
      .nullable(),
    date: z
      .object({
        id: z.union([z.string(), z.number()]),
        label: z.string(),
        value: z.custom<string>(),
      })
      .nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.cancellationReason) {
      ctx.addIssue({
        path: ["cancellationReason"],
        code: "custom",
        message: "Cancellation Reason is required",
      });
    }

    if (!data.date) {
      ctx.addIssue({
        path: ["date"],
        code: "custom",
        message: "Cancellation Date is required",
      });
    }
  });
